'use strict';

(function (angular) {
    angular.module('zp').constant('cities', [{
        name: 'Beograd',
        address: 'beograd',
        latitude: 44.802358,
        longitude: 20.466471,
        radius: 20000
    }, {
        name: 'Novi Sad',
        address: 'novi-sad',
        latitude: 45.254252,
        longitude: 19.842494,
        radius: 30000
    }, {
        name: 'Kragujevac',
        address: 'kragujevac',
        latitude: 44.010621,
        longitude: 20.918591,
        radius: 20000
    }, {
        name: 'Niš',
        address: 'nis',
        latitude: 43.321001,
        longitude: 21.895551,
        radius: 150000
    }, {
        name: 'Čačak',
        address: 'cacak',
        latitude: 43.889579,
        longitude: 20.349297,
        radius: 30000
    }]);
})(window.angular);